export function initForSonTerms() {
  return [{
    inOperator: 'and',
    terms: [{
      attr: 'attr',
      attr_label: '',
      relationship: '',
      relationOptions: [],
      value: null,
      option: [],
      eventAttrOptions: [{
        attributeContent: '',
        relationOptions: [],
        sources: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_type: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValueStart: '',
        attributeValueEnd: '',
        attributeValue: ''
      }],
      selectedOptions: ['attr', '']
    }]
  }]
}
export const resetForSonTerms = [{
  inOperator: 'and',
  terms: [{
    attr: 'attr',
    attr_label: '',
    relationship: '',
    relationOptions: [{
      value: 'equal',
      label: '等于'
    }, {
      value: 'not_equal',
      label: '不等于'
    }, {
      value: 'contain',
      label: '包含'
    }, {
      value: 'empty',
      label: '为空'
    },
    {
      value: 'not_empty',
      label: '不为空'
    }
    ],
    value: null,
    option: [],
    //              original_id: null,
    //              eventAttributeList: [],
    //              activitiesTwo: [],
    //              templatesTwo: [],
    //              wepageTwo: [],
    eventAttrOptions: [{
      attributeContent: '',
      relationOptions: [],
      sources: [],
      eventAttrValueOptions: [],
      attributeRelation: '',
      attr_type: '',
      attrValTimeStart: '',
      attrValTimeEnd: '',
      attributeValueStart: '',
      attributeValueEnd: '',
      attributeValue: ''
    }],
    //              optionOther: null,
    //              qrcodeOptions: null,
    //              templateOption: null,
    //              qrcode: null,
    //              offline_qrcode: null,
    //              template_id: null,
    //              leave_word: null,
    //              public_reply_type_all: {
    //                reply_type: '不限',
    //                reply_content: ''
    //              },
    //              eventLimitTime: false,
    //              eventLimitTimes: false,
    //              eventLimitAttr: false,
    //              eventTimeRelation: '',
    //              eventDateStart: '',
    //              eventDateEnd: '',
    //              happenedTimes: '',
    //              start_time: '',
    //              end_time: '',
    selectedOptions: ['attr', '']
  }]
}]


export const queryObj = {
  allRelationship: 'and',
  termsGroup: [{
    inOperator: 'and',
    terms: [{
      attr: 'attr',
      attr_label: '',
      relationship: '',
      relationOptions: [{
        value: 'equal',
        label: '等于'
      }, {
        value: 'not_equal',
        label: '不等于'
      }, {
        value: 'contain',
        label: '包含'
      }, {
        value: 'empty',
        label: '为空'
      },
      {
        value: 'not_empty',
        label: '不为空'
      }
      ],
      value: null,
      option: [],
      startValue: '',
      endValue: '',
      // original_id: null,
      // eventAttributeList: [],
      // activitiesTwo: [],
      // templatesTwo: [],
      // wepageTwo: [],
      eventAttrOptions: [{
        attributeContent: '',
        relationOptions: [],
        sources: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_type: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValueStart: '',
        attributeValueEnd: '',
        attributeValue: ''
      }],
      // optionOther: null,
      // qrcodeOptions: null,
      // templateOption: null,
      // qrcode: null,
      // offline_qrcode: null,
      // template_id: null,
      // leave_word: null,
      // public_reply_type_all: {
      //  reply_type: '不限',
      //  reply_content: ''
      // },
      // eventLimitTime: false,
      // eventLimitTimes: false,
      // eventLimitAttr: false,
      // eventTimeRelation: '',
      // eventDateStart: '',
      // eventDateEnd: '',
      // happenedTimes: '',
      // start_time: '',
      // end_time: '',
      selectedOptions: ['attr', '']
    }]
  }]
}

export const vmAllTermsObj = {
  allRelationship: 'and',
  termsGroup: [{
    inOperator: 'and',
    terms: [{
      attr: 'attr',
      attr_label: '',
      relationship: '',
      relationOptions: [{
        value: 'equal',
        label: '等于'
      }, {
        value: 'not_equal',
        label: '不等于'
      }, {
        value: 'contain',
        label: '包含'
      }, {
        value: 'empty',
        label: '为空'
      },
      {
        value: 'not_empty',
        label: '不为空'
      }
      ],
      value: null,
      option: [],
      startValue: '',
      endValue: '',
      // original_id: null,
      // eventAttributeList: [],
      // activitiesTwo: [],
      // templatesTwo: [],
      // wepageTwo: [],
      eventAttrOptions: [{
        attributeContent: '',
        relationOptions: [],
        sources: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_type: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValueStart: '',
        attributeValueEnd: '',
        attributeValue: ''
      }],
      // optionOther: null,
      // qrcodeOptions: null,
      // templateOption: null,
      // qrcode: null,
      // offline_qrcode: null,
      // template_id: null,
      // leave_word: null,
      // public_reply_type_all: {
      //  reply_type: '不限',
      //  reply_content: ''
      // },
      // eventLimitTime: false,
      // eventLimitTimes: false,
      // eventLimitAttr: false,
      // eventTimeRelation: '',
      // eventDateStart: '',
      // eventDateEnd: '',
      // happenedTimes: '',
      // start_time: '',
      // end_time: '',
      selectedOptions: ['attr', '']
    }]
  }]
}

export const vmForSonTermsList = [{
  inOperator: 'and',
  terms: [{
    attr: 'attr',
    attr_label: '',
    relationship: '',
    relationOptions: [{
      value: 'equal',
      label: '等于'
    }, {
      value: 'not_equal',
      label: '不等于'
    }, {
      value: 'contain',
      label: '包含'
    }, {
      value: 'empty',
      label: '为空'
    },
    {
      value: 'not_empty',
      label: '不为空'
    }
    ],
    value: null,
    option: [],
    startValue: '',
    endValue: '',
    //                original_id: null,
    //                eventAttributeList: [],
    //                activitiesTwo: [],
    //                templatesTwo: [],
    //                wepageTwo: [],
    eventAttrOptions: [{
      attributeContent: '',
      relationOptions: [],
      sources: [],
      eventAttrValueOptions: [],
      attributeRelation: '',
      attr_type: '',
      attrValTimeStart: '',
      attrValTimeEnd: '',
      attributeValueStart: '',
      attributeValueEnd: '',
      attributeValue: ''
    }],
    //                optionOther: null,
    //                qrcodeOptions: null,
    //                templateOption: null,
    //                qrcode: null,
    //                offline_qrcode: null,
    //                template_id: null,
    //                leave_word: null,
    //                public_reply_type_all: {
    //                  reply_type: '不限',
    //                  reply_content: ''
    //                },
    //                eventLimitTime: false,
    //                eventLimitTimes: false,
    //                eventLimitAttr: false,
    //                eventTimeRelation: '',
    //                eventDateStart: '',
    //                eventDateEnd: '',
    //                happenedTimes: '',
    //                start_time: '',
    //                end_time: '',
    selectedOptions: ['attr', '']
  }]
}]



export const aduRelateOpsOne = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
},
{
  value: 'contain',
  label: '包含'
},
{
  value: 'not_contain',
  label: '不包含'
}
]
export const aduRelateOpsTwo = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'before',
  label: '早于'
},
{
  value: 'past',
  label: '晚于'
},
{
  value: 'gtele',
  label: '区间'
}
]
export const aduRelateOpsThree = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
},
{
  value: 'contain',
  label: '包含'
}
]
export const aduRelateOpsFour = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'gt',
  label: '大于'
},
{
  value: 'gte',
  label: '大于等于'
},
{
  value: 'lt',
  label: '小于'
},
{
  value: 'lte',
  label: '小于等于'
},
{
  value: 'gtele',
  label: '区间'
}
]
export const aduRelateOpsFive = [{
  value: 'equal',
  label: '等于'
}, {
  value: 'not_equal',
  label: '不等于'
}, {
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
}
]

export const aduRelateOpsSix = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'gt',
  label: '大于'
},
{
  value: 'lt',
  label: '小于'
},
{
  value: 'gtele',
  label: '区间'
}
]

export const aduRelateOpsSeven = [{
  value: 'contain',
  label: '包含'
},
{
  value: 'not_contain',
  label: '不包含'
},
{
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
}
]

export const aduRelateOpsEight = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'lt',
  label: '早于'
},
{
  value: 'gt',
  label: '晚于'
},
{
  value: 'gtele',
  label: '区间'
},
{
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
}
]

export const elseForSonTermsList = [{
  inOperator: 'and',
  terms: [{
    attr: 'attr',
    attr_label: '',
    relationship: '',
    modelItemId: '',
    relationOptions: [{
      value: 'equal',
      label: '等于'
    }, {
      value: 'not_equal',
      label: '不等于'
    }, {
      value: 'contain',
      label: '包含'
    }, {
      value: 'empty',
      label: '为空'
    },
    {
      value: 'not_empty',
      label: '不为空'
    }
    ],
    value: null,
    option: [],
    startValue: '',
    endValue: '',
    //                original_id: null,
    //                eventAttributeList: [],
    //                activitiesTwo: [],
    //                templatesTwo: [],
    //                wepageTwo: [],
    eventAttrOptions: [{
      attributeContent: '',
      relationOptions: [],
      sources: [],
      eventAttrValueOptions: [],
      attributeRelation: '',
      attr_type: '',
      attrValTimeStart: '',
      attrValTimeEnd: '',
      attributeValueStart: '',
      attributeValueEnd: '',
      attributeValue: ''
    }],
    //                optionOther: null,
    //                qrcodeOptions: null,
    //                templateOption: null,
    //                qrcode: null,
    //                offline_qrcode: null,
    //                template_id: null,
    //                leave_word: null,
    //                public_reply_type_all: {
    //                  reply_type: '不限',
    //                  reply_content: ''
    //                },
    //                eventLimitTime: false,
    //                eventLimitTimes: false,
    //                eventLimitAttr: false,
    //                eventTimeRelation: '',
    //                eventDateStart: '',
    //                eventDateEnd: '',
    //                happenedTimes: '',
    //                start_time: '',
    //                end_time: '',
    selectedOptions: ['attr', '']
  }]
}]

export const termsObj = {
  allRelationship: 'and',
  termsGroup: [{
    inOperator: 'and',
    terms: elseForSonTermsList
  }]
}

export const GROUP_TYPE = Object.freeze({
  static: '2',
  dynamic: '1'
})

export const GROUP_TYPE_OBJ = Object.freeze({
  1: '动态群组',
  2: '静态群组'
})

export const initAuDetailSonTermsList = [{
  inOperator: 'and',
  terms: [{
    attr: 'attr',
    attr_label: '真实姓名',
    relationship: '',
    relationOptions: [{
      value: '=',
      label: '等于'
    }, {
      value: '!=',
      label: '不等于'
    }, {
      value: 'contain',
      label: '包含'
    }, {
      value: 'empty',
      label: '为空'
    },
    {
      value: 'not empty',
      label: '不为空'
    }
    ],
    value: null,
    original_id: null,
    eventAttributeList: [],
    activitiesTwo: [],
    templatesTwo: [],
    wepageTwo: [],
    eventAttrOptions: [{
      attributeContent: '',
      relationOptions: [],
      sources: [],
      eventAttrValueOptions: [],
      attributeRelation: '',
      attr_type: '',
      attrValTimeStart: '',
      attrValTimeEnd: '',
      attributeValueStart: '',
      attributeValueEnd: '',
      attributeValue: ''
    }],
    optionOther: null,
    qrcodeOptions: null,
    templateOption: null,
    qrcode: null,
    offline_qrcode: null,
    template_id: null,
    leave_word: null,
    public_reply_type_all: {
      reply_type: '不限',
      reply_content: ''
    },
    eventLimitTime: false,
    eventLimitTimes: false,
    eventLimitAttr: false,
    eventTimeRelation: '',
    eventDateStart: '',
    eventDateEnd: '',
    happenedTimes: '',
    start_time: '',
    end_time: '',
    selectedOptions: ['attr', '']
  }]
}]

export const SUCCESS_CODE = '200'

export const IS_CHECKED = 1

export const GROUP_TAG_OPTION_OBJ = Object.freeze({
  'group': 'groupId',
  'tag': 'tags'
})

export const GROUP_TAG_VALUE_OBJ = Object.freeze({
  'group': '静态群组',
  'tag': '标签'
})

export const GROUP_TAG_FUN_KEY = Object.freeze({
  'group': 'Groups',
  'tag': 'Tags'
})
export const INIT_SEARCH = {
  allRelationship: 'and',
  termsGroup: [{
    inOperator: 'and',
    terms: [{
      attr: 'attr',
      attr_label: '',
      relationship: '',
      relationOptions: null,
      value: null,
      option: null,
      startValue: '',
      endValue: '',
      eventAttrOptions: [{
        attributeContent: '',
        relationOptions: [

        ],
        sources: [

        ],
        eventAttrValueOptions: [

        ],
        attributeRelation: '',
        attr_type: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValueStart: '',
        attributeValueEnd: '',
        attributeValue: ''
      }],
      selectedOptions: [
        'attr',
        ''
      ],
      secAttr: ''
    }]
  }]
}
export const FIRST_PAGE = 1
export const EXPORT = 1
export const NO_EXPORT = 0